/**
 * MFA Constants
 * Shared constants for Multi-Factor Authentication screens
 */

/**
 * Default OTP code length for MFA challenges (SMS, Email, etc.)
 */
export const MFA_OTP_CODE_LENGTH = 6;

/**
 * Default resend timeout in seconds
 */
export const MFA_RESEND_TIMEOUT_SECONDS = 30;

/**
 * Cookie name for MFA redirect
 */
export const MFA_REDIRECT_COOKIE = 'mfa-redirect';
